import { render } from "./HeroiconsOutlineVolumeUp.vue?vue&type=template&id=ab8048e6"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVolumeUp.vue"]])

export default __exports__